import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Sh3Service {

  constructor( private httpService: HttpService) { }


  samplesh3Record(object) {
      console.log("object", object);
      var request = {
          URL: "sh3/sh3Entry",
          DATA: object
      }
      return this.httpService.post(request);
  }

  updateTotalEmployeeDirector(total)
  {
      var request = {
          URL: "sh3/updateSh3total",
          DATA: total
      }
      return this.httpService.post(request);
  }

  lockDetails(lockindetails)
  {
      var request = {
          URL: "sh3/sh3lockdetails",
          DATA: lockindetails
      }
     return this.httpService.post(request);
  }

  valuationDetails(valuationdetails)
  {
    var request = {
        URL: "sh3/sh3valuationdetails",
        DATA: valuationdetails
    }
    return this.httpService.post(request);
  }

  getRegisterDirector(object) {
      var registerList = {
          URL: "sh3/getsh3/5cee33d225242e023acfb2d4",
          DATA:object
      }
      return this.httpService.post(registerList);
  }

  removesh3details(_id) {
      var request = {
          URL: "sh3/deletedetails/" + _id
      }
      return this.httpService.get(request);
  }
  update(_id){
      var editlist = {
          URL: "sh3/update/" + _id,
      }
      return this.httpService.get(editlist);
  }

  sh3Update(object, _id){
      var request = {
          URL: "sh3/updateSh3/" + _id,
          DATA: object
      }
      return this.httpService.post(request);
  }

  generateSh3Document(object) {
      var request = {
          URL: "sh3/generateSh3Document",
          DATA: object
      }
      return this.httpService.post(request);
  }

  downloadSh3File(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "sh3/downloadDocument/" + id + "/" + type + "/" + token;
  }

  downloadSh3PdfFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "sh3/downloadPdfDocument/" + id + "/" + type + "/" + token;
  }
 
}

